import React, { lazy, Suspense } from "react";
import { Route, Redirect, Switch } from "react-router-dom";
import LoggedInOnly from "../components/LoggedInOnly";
import NotLoggedInOnly from "../components/NotLoggedInOnly";
import Disclaimer from "./Disclaimer";
import LoadingPage from "./LoadingPage";
import Privacy from "./Privacy";
import ThankYouCart from "./ThankYouCart";
import Terms from "./Terms";
import Employment from "./Employment";

const HomeLearn  = lazy(() => import("./HomeLearn"))
const ComingSoon  = lazy(() => import("./ComingSoon"))
const DesignYourRoom  = lazy(() => import("./DesignYourRoom"))
const Floors = lazy(() => import('./Floors'))
const Installers = lazy(() => import('./Installers'))
const AboutUs = lazy(() => import('./AboutUs'))
const ContactUs = lazy(() => import('./ContactUs'))
const Learn = lazy(() => import('./Learn'))
const FloorProfile = lazy(() => import("./FloorProfile"))
const MyCart = lazy(() => import("./MyCart"))
const FloorReviews = lazy(() => import("./FloorReviews"))
const Invoices = lazy(() => import("./Invoices"))
const MyOrders = lazy(() => import("./MyOrders"))
const AddCreditCard = lazy(() => import("./AddCreditCard"))
const OurWorks = lazy(() => import("./OurWorks"));

let only_logged_in = [
    { path: "/become_installer", Component: lazy(() => import('./BecomeInstaller')) },
    { path: "/thank_you_installer", Component: lazy(() => import('./ThankYouCart')) },
    { path: "/my_profile", Component: lazy(() => import('./MyProfile')) },
    // { path: "/installers", Component: lazy(() => import('./Installers')) },
    // { path: "/floors", Component: lazy(() => import('./Floors')) },
    { path: "/logout", Component: lazy(() => import('./Logout')) }
]

let only_not_logged_in = [
    { path: "/login", Component: lazy(() => import('./Login')) },
    { path: "/forgot_password", Component: lazy(() => import('./ForgotPassword')) },
    { path: "/register", Component: lazy(() => import('./Register')) },
    { path: "/", Component: lazy(() => import('./HomeLearn')) }
]

export default () => {
    return (
        <Suspense fallback={<LoadingPage/>}>
            <Route exact path={"/home-learn"} component={HomeLearn}/>
            <Route exact path={"/coming-soon"} component={ComingSoon}/>
            <Route exact path={"/thank-you-cart"} component={ThankYouCart}/>
            <Route exact path={"/invoices"} component={Invoices}/>
            <Route exact path={"/privacy"} component={Privacy}/>
            <Route exact path={"/employment"} component={Employment}/>
            <Route exact path={"/disclaimer"} component={Disclaimer}/>
            <Route exact path={"/terms"} component={Terms}/>
            <Route exact path={"/my_orders"} component={MyOrders}/>
            <Route exact path={"/our_works"} component={OurWorks}/>
            <Route exact path={"/add_credit_card"} component={AddCreditCard}/>

            <Route exact path={"/design-your-room"} component={DesignYourRoom}/>
            <Route exact path={"/floors"} component={Floors}/>
            <Route exact path={"/installers"} component={Installers}/>
            <Route exact path={"/about-us"} component={AboutUs}/>
            <Route exact path={"/contact-us"} component={ContactUs}/>
            <Route exact path={"/learn"} component={Learn}/>
            <Route exact path={"/my_cart"} component={MyCart}/>
            <Route exact path={"/floor/:id"} component={FloorProfile}/>
            <Route exact path={"/floor/:floor_id/reviews"} component={FloorReviews}/>
            {
                only_logged_in.map(({path, Component},i) => (
                        <Route key={i} exact path={path} component={props => {
                            return (
                                <LoggedInOnly redirect_to="/login">
                                    <Component {...props}/>
                                </LoggedInOnly>
                            )
                        }} />
                ))
            }
            {
                only_not_logged_in.map(({path, Component},i) => (
                        <Route key={i} exact path={path} component={props => {
                            return (
                                <NotLoggedInOnly redirect_to="/home-learn">
                                    <Component {...props}/>
                                </NotLoggedInOnly>
                            )
                        }} />
                ))
            }
        </Suspense>
    )
}